<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-09-24 12:39:25
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-12-05 18:01:01
 * @FilePath: \music\src\view\aside.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="aside_box">
        <el-popover placement="left-end" :open-delay="500" trigger="hover">
            <img :src="($env.VUE_APP_URL + $store.state.service)" alt="" class="qrcode" style="width: 150px;height:150px">
            <div class="aside_item" slot="reference">
                <img src="../assets/home/service.png" alt="">
                <p>联系 客服</p>
            </div>
        </el-popover>
        <!-- <div class="line"></div> -->
        <!-- <div class="aside_item">
            <img src="../assets/home/帮助 (5) 1.png" alt="">
            <p>帮助 中心</p>
        </div> -->
        <div class="line"></div>
        <div class="aside_item" @click="top">
            <img src="../assets/home/top.png" alt="">
            <p>回到 顶部</p>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        top() {
            // 使用方法
            this.$scrollTo()
        }
    }
}
</script>
<style lang="scss" scoped>
.aside_box {
    position: fixed;
    right: 0px;
    z-index: 9999;
    top: 50%;
    transform: translateY(-50%);
    background: #F8F8F8;

    .qrcode {
        width: 150px !important;
        height: 150px !important;
    }


    .aside_item {
        width: 40px;
        cursor: pointer;

        &:hover {
            background-color: rgba(0, 0, 0, .03);
        }

        img {
            width: 22px;
            height: 22px;
        }

        height: 73px;
        font-size: 12px;
        font-family: PingFang SC-Regular,
        PingFang SC;
        font-weight: 400;
        color: #999999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        p {
            width: 30px;
            margin: auto;
            margin: 0;
        }

    }
}

.line {
    width: 24px;
    height: 0px;
    opacity: 1;
    border: 1px solid #E4E4E4;
    margin: auto;
}
</style>